import LocationConfirmationBanner from './LocationConfirmationBanner/index.js';
import ClubStore from 'framework/stores/ClubStore.js';

var clubData = ClubStore.getInitialData();
var geolocationEls = document.querySelectorAll('.js-geolocation');
var shouldShow = LocationConfirmationBanner.getLastPageCookie() == null;

function initBanner(i) {
	let mount = geolocationEls[i];

	let banner = new LocationConfirmationBanner(clubData, mount);

	if(clubData.name) {
		banner.initialize();
	}
	ClubStore.listen((newClubData) => {
		mount.innerHTML = '';
		banner = new LocationConfirmationBanner(newClubData, mount);
		banner.initialize();
	});
}

for(let i = 0; shouldShow && i < geolocationEls.length; i++){
	initBanner(i);
}
